<template>
    <div>
        <BaseTable
            :flat="true"
            title="Calendario de cobros"
            subtitle="Calendario de cobros programados"
            :columns="columns"
            :data="paginatedData"
            :skeleton="loading"
            :skeleton-rows="5"
            :empty-text="'No hay calendario de cobros'"
            customClass="tw:border-none"
            :default-col-width="defaultColWidth"
        >
            <!-- Skeleton headers -->
            <template #skeleton-header-fecha_cobro_plazo>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-20"></div>
            </template>
            <template #skeleton-header-total>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-16"></div>
            </template>
            <template #skeleton-header-importe_total>
                <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-14"></div>
            </template>

            <!-- Skeleton rows -->
            <template #skeleton-fecha_cobro_plazo>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-32"></div>
            </template>
            <template #skeleton-total>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-12"></div>
            </template>
            <template #skeleton-importe_total>
                <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-12"></div>
            </template>

            <template #cell-importe_total="{ value }">
                {{ formatPrice(value) }}
            </template>
        </BaseTable>
        <TablePagination
            v-if="totalItems > perPage"
            :value="page"
            :total="totalItems"
            :per-page="perPage"
            @input="page = $event"
        />
    </div>
</template>

<script setup>
    import { ref, computed, onMounted } from 'vue';
    import store from '@/store';
    import { config } from '@/config.js';
    import BaseTable from '@/modules/admin/ui/table/BaseTable.vue';
    import TablePagination from '@/modules/admin/ui/table/TablePagination.vue';
    import filters from '@/filters';

    const props = defineProps({
        listaId: { type: [Number, String], required: true },
        defaultColWidth: {
            type: String,
            default: '90px'
        }
    });

    const loading = ref(false);
    const calendario = ref([]);
    const page = ref(1);
    const perPage = 10;

    const columns = [
        { key: 'fecha_cobro_plazo', label: 'Fecha', centered:true, class: 'tw:w-32 tw:sm:w-auto' },
        { key: 'total', label: 'Nº cobros', centered:true, class: ' tw:sm:w-auto'},
        { key: 'importe_total', label: 'Total', centered:true ,class: ' tw:sm:w-auto'}
    ];

    const totalItems = computed(() => calendario.value.length);

    const paginatedData = computed(() => {
        const start = (page.value - 1) * perPage;
        return calendario.value.slice(start, start + perPage);
    });

    const formatPrice = filters.formatear_precio;

    onMounted(async() => {
        loading.value = true;
        try {
            const res = await store.dispatch(
                config.getVuexAlias('back.bases.informe.plazos-calendarios-cobro'),
                { lista_id: props.listaId, filters: {} }
            );
            calendario.value = res.data.plazos_calendario_cobros || [];
        } catch (e) {
            console.error('Error fetching calendario de cobros:', e);
        } finally {
            loading.value = false;
        }
    });

</script>
